/** @file Maps a selected key (KeyRef) to the curve timeline it lies on, or null for a discrete key. */
import { IK_CHANNELS } from '@pose2d/api/queries/ikChannels.data';
import type { KeyRef } from '../../stores/types';
import { CURVE_CHANNELS } from './curveChannels.data';
import type { CurveChannel, CurveRef } from './curveTypes';

/** KeyRef.channel holds the animation.setCurve channel name; the IK timeline props `mix`/`softness` map too. */
export function toCurveRef(key: KeyRef): CurveRef | null {
  const name = Object.hasOwn(IK_CHANNELS, key.channel) ? (IK_CHANNELS[key.channel] ?? key.channel) : key.channel;
  if (!Object.hasOwn(CURVE_CHANNELS, name)) return null;
  return { animation: key.animation, channel: name as CurveChannel, target: key.target };
}
